import React from "react";

import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import { TextEditor } from "../text-editor/text-editor";
import { TextMarkerEditor as TextMarkerEditorProps } from "./hooks";

export const TextMarkerEditor = ({
  isTextEditorOpen,
  textMarkerEditing,
  setTextMarkerText,
  onSubmitTextEdit,
  cancelTextEdit,
}: TextMarkerEditorProps) => {
  return (
    <Modal
      isOpen={isTextEditorOpen}
      title="Text Editor"
      actions={[
        <Button intent="danger" text="Cancel" minimal key={0} onClick={cancelTextEdit} />,
        <Button intent="primary" text="Save" key={1} onClick={onSubmitTextEdit} />,
      ]}
    >
      <TextEditor
        htmlText={textMarkerEditing?.label || ""}
        showListOption={false}
        onTextEditorBlur={setTextMarkerText}
      />
    </Modal>
  );
};
